import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, zip, lastValueFrom} from 'rxjs';

import {catchError, tap} from 'rxjs/operators';
import {ConfigurationService} from './configuration.service';
import {HttpHeaders} from '@angular/common/http';
import {ErrorService} from "./error.service";
import {GLItem} from '../shared/model/GLItem';
import {GLGuide} from '../shared/model/GLGuide';
import {GLCode} from '../shared/model/GLCode';
import {GLReview} from "../shared/model/GLReview";
import {GLAudit} from "../shared/model/GLAudit";
import {DatePipe} from "@angular/common";
import {UserService} from "./user.service";
import {LoggingService} from "mclane-apptemplate-lib";
import {BaseService} from "~/app/core/services/base.service";

const CREATE_ACTION = 'create';
const UPDATE_ACTION = 'update';
const REMOVE_ACTION = 'destroy';

const itemIndex = (item: any, data: any[]): number => {
  if (data != undefined) {
    for (let idx = 0; idx < data.length; idx++) {
      if (data[idx].itemNo === item.itemNo) {
        return idx;
      }
    }
  }
  return -1;
};

const cloneData = (data: any[]) => data.map(item => Object.assign({}, item));

@Injectable({
  providedIn: 'root'
})
export class GlguideService extends BehaviorSubject<any[]> {
  get glguidedescription(): string {
    return this._glguidedescription;
  }

  set glguidedescription(value: string) {
    this._glguidedescription = value;
  }

  readonly GUIDELISTURL = '/glguide/getlist';
  readonly GUIDECODEURL = '/glguide/getcodes';
  readonly ADDCATURL = '/glguide/add/codecategory';
  readonly UPDATECATURL = '/glguide/update/codecategory';
  readonly DELETECATURL = '/glguide/delete/codecategory';
  readonly GETITEMSURL = '/glguide/getitems';
  readonly CODECOUNTURL = '/glguide/getcodecount';
  readonly NEXTSEQURL = '/glguide/getnextseq';
  readonly UPDATEHEADER = '/glguide/update/guideheader';
  readonly ADDITEM = '/glguide/add/item';
  readonly UPDATEITEM = '/glguide/update/item';
  readonly DELETEITEM = '/glguide/delete/item';
  readonly GETCATDESC = '/glguide/describecat';
  readonly GETITEMDESC = '/glguide/describeitem';
  readonly AUDITLIST = '/glguide/audit';
  readonly GETALLITEMS = '/glguide/allitems' // /{glguide}

  public _glguide: number;
  private data: any[];
  private _glguidedescription: string;
  private _data: any[] = [];
  private _originalData: any[] = [];
  private _createdItems: any[] = [];
  private _updatedItems: any[] = [];
  private _deletedItems: any[] = [];
  private _selectedCategory: string;
  private _valueChanged: boolean;
  private _glItems: Array<GLItem> = new Array<GLItem>();
  private _glCodes: Array<GLCode> = new Array<GLCode>();
  private _altseq: any;
  private _rowIndex: number;
  private _previousCategory: string = '';
  private _previousItemNo: number;
  items: Array<GLItem>;

  public glReviewList: Array<GLReview>;
  public glAuditList: Array<GLAudit>;

  httpOptions = {
    headers: new HttpHeaders({
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'text/plain',
    }),
  };

  constructor(private configuration: ConfigurationService,
              private errorService: ErrorService,
              public userService: UserService,
              public datepipe: DatePipe,
              public console: LoggingService,
              public baseService: BaseService) {
    super([]);
  }

  setPreviousItemNo(itemNo: number) {
    this._previousItemNo = itemNo;
  }

  getPreviousItemNo(): number {
    return this._previousItemNo;
  }

  setPreviousRowIndex(rowIndex: number) {
    this._rowIndex = rowIndex;
  }

  getPreviousRowIndex(): number {
    return this._rowIndex;
  }

  setPreviousCategory(prevCat: string) {
    this._previousCategory = prevCat;
  }

  getPreviousCategory(): string {
    return this._previousCategory;
  }

  getUpdatedItems() {
    return this._updatedItems;
  }

  setUpdatedItemsNull() {
    this._updatedItems = [];
  }

  setselectedCategory(category: string) {
    this._selectedCategory = category;
  }

  getselectedCategory() {
    return this._selectedCategory;
  }

  setCategoryChanged(change: boolean): void {
    this._valueChanged = change;
  }

  getCategoryChanged() {
    return this._valueChanged;
  }

  setglguide(glguide: number) {
    this._glguide = glguide;
  }

  getglguide() {
    return this._glguide;
  }

  setGLItems(glItems: Array<GLItem>) {
    this._glItems = glItems;
  }

  getGLItems(): Array<GLItem> {
    return this._glItems;
  }

  setCodes(glCodes: Array<GLCode>) {
    this._glCodes = glCodes;
  }

  getCodes(): Array<GLCode> {
    return this._glCodes;
  }

  getGLGuideList(user) {
    return this.baseService.getHttpObject<GLGuide[]>(
      'getGLGuideList',
      'glguide-service',
      this.configuration.RESTURL + this.GUIDELISTURL + "/" + user)
      .pipe(
        catchError(this.errorService.handleError('GLGuideService getGLGuideList', []))
      );
  }

  getGLCodes(guideId) {
    return this.baseService.getHttpObject<GLCode[]>(
      'getGLCodes',
      'glguide-service',
      this.configuration.RESTURL + this.GUIDECODEURL + "/" + guideId)
      .pipe(
        catchError(this.errorService.handleError('GLguideService getGlCodes', []))
      );
  }


  addGLCategory(glGuide, glCode, glSequence, glDescription, user): Observable<any> {
    const data = {
      'glGuide': glGuide,
      'glCode': glCode,
      'glSequence': glSequence,
      'glDescription': glDescription,
      'user': user
    };
    return this.baseService.postHttpObject<any>(
      'addGLCategory',
      'glguide-service',
      this.configuration.RESTURL + this.ADDCATURL, JSON.stringify(data))
      .pipe(
        catchError(this.errorService.handleError('GLGuideService addGLCagegory()', []))
      );
  }

  updateGLCategory(action: string = '', glGuide, glCode, glSequence, glDescription, user): Observable<any> {
    const data = {
      'glGuide': glGuide,
      'glCode': glCode,
      'glSequence': glSequence,
      'glDescription': glDescription,
      'user': user
    };
    return this.baseService.putHttpObject<any>(
      'updateGLCategory',
      'glguide-service',
      this.configuration.RESTURL + this.UPDATECATURL, data, {observe: 'response'})
      .pipe(
        catchError(this.errorService.handleError('GLGuideService updateGLCategory', []))
      );

  }

  deleteCategory(action: string = '', glGuide, glCode): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        'glGuide': glGuide,
        'glCode': glCode,
      },
    };
    return this.baseService.deleteHttpObject<any>(
      'deleteCategory',
      'glguide-service',
      this.configuration.RESTURL + this.DELETECATURL, options)
      .pipe(
        catchError(this.errorService.handleError('GLGuideService deleteCategory()', []))
      );
  }

  async getGLGuide() {
    const results = await lastValueFrom(this.baseService.getHttp(
      'deleteCategory',
      'glguide-service',
      this.configuration.RESTURL + this.GETITEMSURL + "/" + this._glguide));
    return results as GLReview[];
  }

  async getGLGuideItems() {
    this.glReviewList = await this.getGLGuide();
    return this.glReviewList;
  }

  async getGLAudit(startDate: Date, endDate: Date) {
    const results = await lastValueFrom(this.baseService.getHttp(
      'getGLAudit',
      'glguide-service',
      this.configuration.RESTURL + this.AUDITLIST
      + "/" + this.userService.getUserName()
      + "/" + this.datepipe.transform(startDate, 'yyyy-MM-dd')
      + "/" + this.datepipe.transform(endDate, 'yyyy-MM-dd')));
    return results as GLAudit[];
  }

  async getGLAuditItems(startDate: Date, endDate: Date) {
    this.glAuditList = await this.getGLAudit(startDate, endDate);
    return this.glAuditList;
  }

  deleteItem(glGuide, seq, itemNo): Observable<any> {
    let data = {
      'glGuide': glGuide,
      'seq': seq,
      'itemNo': itemNo
    }
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    }
    return this.baseService.deleteHttpObject<any>(
      'deleteItem',
      'glguide-service',
      this.configuration.RESTURL + this.DELETEITEM, options)
      .pipe(
        catchError(this.errorService.handleError('GLGuideService deleteItem()', []))
      );
  }

  getItemList(glGuide) {
    return this.baseService.getHttpObject<GLItem[]>(
      'getItemList',
      'glguide-service',
      this.configuration.RESTURL + this.GETITEMSURL + "/" + glGuide)
      .pipe(
        catchError(this.errorService.handleError('GLGuideService getItemList()', []))
      );
  }

  addGLItem(glGuide, glCode, glSequence, itemNo, lastSeq, user) {
    const data = {
      'glGuide': glGuide,
      'glCode': glCode,
      'glSequence': glSequence,
      'itemNo': itemNo,
      'lastSeq': lastSeq,
      'user': user
    };
    return this.baseService.postHttpObject<any>(
      'addGLItem',
      'glguide-service',
      this.configuration.RESTURL + this.ADDITEM, JSON.stringify(data), {observe: 'response'})
      .pipe(
        catchError(this.errorService.handleError('GLGuideService addGLItem()', []))
      );
  }

  getNextSeq(glGuide) {
    return this.baseService.getHttpObject<any>(
      'getNextSeq',
      'glguide-service',
      this.configuration.RESTURL + this.NEXTSEQURL + "/" + glGuide)
      .pipe(
        catchError(this.errorService.handleError('GLGuideService getItemList()', []))
      );
  }

  updateGuideHeader(lastSeq, glGuide): Observable<any> {
    const data = {
      'lastSeq': lastSeq,
      'glGuide': glGuide
    };
    return this.baseService.putHttpObject<any>(
      'updateGuideHeader',
      'glguide-service',
      this.configuration.RESTURL + this.UPDATEHEADER, JSON.stringify(data), {observe: 'response'})
      .pipe(
        catchError(this.errorService.handleError('GLGuideService updateGuideHeader()', []))
      );
  }

  updateGLItem(glGuide, itemNo, lastSeq, user) {
    const data = {
      'glGuide': glGuide,
      'glCode': lastSeq,
      'itemNo': itemNo,
      'lastSeq': lastSeq,
      'user': user
    };
    return this.baseService.putHttpObject<any>(
      'updateGLItem',
      'glguide-service',
      this.configuration.RESTURL + this.UPDATEITEM, JSON.stringify(data), {observe: 'response'})
      .pipe(
        catchError(this.errorService.handleError('GlGuideService updateGLItem', []))
      )
  }

  public read(glguide) {
    if (this.data) {
      return super.next(this.data);
    }
    this.getGLCodes(glguide)
      .pipe(
        tap(data => {
          this.data = data;
        })
      )
      .subscribe(data => {
        super.next(data);
      });
  }

  public save(glGuide, glCode, glSequence, glDescription, user, isNew?: boolean) {
    const action = UPDATE_ACTION;

    this.reset();

    this.updateGLCategory(action, glGuide, glCode, glSequence, glDescription, user)
      .subscribe({next: () =>{
         this.read(glGuide), () => this.read(glGuide)
        }});
  }

  public removeItem(glGuide, seq, itemNo) {
    this.reset();

    this.deleteItem(glGuide, seq, itemNo)
      .subscribe({next: () =>{
        this.read(glGuide), () => this.read(glGuide)
      }});
  }

  public reset() {
    this._data = [];
    this._deletedItems = [];
    this._updatedItems = [];
    this._createdItems = [];
    this.setCategoryChanged(false);
  }

  public hasChanges(): boolean {
    let changed = this.getCategoryChanged();
    return Boolean(this._deletedItems.length || this._updatedItems.length || this._createdItems.length || changed == true);
  }

  public cancelChanges(): void {
    this.reset();

    this.data = this._originalData;
    this._originalData = cloneData(this._originalData);
    super.next(this.data);
  }

  public resetItem(dataItem: any) {
    if (!dataItem) {
      return;
    }

    // find orignal data item
    const originalDataItem = this.data.find(item => item.itemNo === dataItem.itemNo);

    // revert changes
    Object.assign(originalDataItem, dataItem);

    super.next(this.data);
  }

  public read1() {

    if (this.data) {
      return super.next(this.data);
    }

    this.getItemList(this.getglguide())
      .subscribe(data => {
        this.data = data;
        this._originalData = cloneData(data);
        super.next(data);
      })
  }

  public getAllItems(glGuideNum: number) {
    return this.baseService.getHttpObject<GLItem[]>(
      'getAllItems',
      'glguide-service',
      this.configuration.RESTURL + this.GETALLITEMS + "/" + glGuideNum)
      .pipe(
        catchError(this.errorService.handleError('GLGuideService getAllItems', []))
      );
  }

  public assignValues(target: any, source: any): void {
    Object.assign(target, source);
  }

  public update(item: any): void {
    if (!this.isNew(item)) {
      const index = itemIndex(item, this._updatedItems);
      if (index !== -1) {
        this._updatedItems.splice(index, 1, item);
      } else {
        this._updatedItems.push(item);
      }
    } else {
      const index = this._createdItems.indexOf(item);
      this._createdItems.splice(index, 1, item);
    }
  }

  public create(item: any): void {
    this._createdItems.push(item);
    this.data.unshift(item);

    super.next(this.data);
  }

  public isNew(item: any): boolean {
    return !item.itemNo;
  }
}
